// List of locale codes supported by the current XTM translation project
// - XTM is specifically configured to output full BCP-47 locale codes for all configured locales.
// - `en` is a special case as it is the base language that we submit to XTM as opposed to something they output.
export enum LocaleCode {
  'de-DE' = 'de-DE',
  'de-CH' = 'de-CH', // Fake translations which hijack the swiss german locale code for testing
  'en' = 'en', // base language code for English
  'en-GB' = 'en-GB',
  'el-GR' = 'el-GR',
  'es-ES' = 'es-ES',
  'fr-FR' = 'fr-FR',
  'it-IT' = 'it-IT',
  'ja-JP' = 'ja-JP',
  'ko-KR' = 'ko-KR',
  'nl-NL' = 'nl-NL',
  'pt-BR' = 'pt-BR',
  'pt-PT' = 'pt-PT',
  'ru-RU' = 'ru-RU',
  'tr-TR' = 'tr-TR',
  'zh-CN' = 'zh-CN',
}

// List of base languages supported by the current XTM translation project
export enum BaseLanguageCode {
  'de' = 'de',
  'en' = 'en',
  'el' = 'el',
  'es' = 'es',
  'fr' = 'fr',
  'it' = 'it',
  'ja' = 'ja',
  'ko' = 'ko',
  'nl' = 'nl',
  'pt' = 'pt',
  'ru' = 'ru',
  'tr' = 'tr',
  'zh' = 'zh',
}

export const DEFAULT_LOCALE_CODE = LocaleCode.en;
